module.exports = __webpack_public_path__ + "img/logo.79361a33.svg";